import Api from "../../services/Api.ts";
import {useEffect, useState} from "react";
import {ChevronDown} from "flowbite-react-icons/outline";
import { useAtom } from 'jotai';
import { categoriesAtom } from '../../jotai_state';
import TooFewClients from "../../components/TooFewClients/TooFewClients.tsx";

interface RowInterface {
  left: string
  right: string
}

interface FeedbackFA {
  title: string
  feedbacks: RowInterface[]
}

interface DataInterface {
  sessions: RowInterface[]
  goals: RowInterface[]
}

export default function Activity() {
  const api = Api.getInstance();
  const [tooFewClients, setTooFewClients] = useState<number|undefined>(undefined);
  const [data, setData] = useState<DataInterface>({
    sessions: [],
    goals: [],
  });
  const [categories] = useAtom(categoriesAtom);
  const [loaded, setLoaded] = useState(false);
  const [expandedFAs, setExpandedFAs] = useState<Array<number>>([]);
  const [error, setError] = useState("");

  useEffect(() => {
    getData()
  }, [categories]);

  const getData = () => {
    const data = {
      categories: categories,
    }

    api.post('customer/user_activity', data).then((response) => {
      if (response.json.data.tooFewClients !== undefined) {
        setTooFewClients(response.json.data.tooFewClients)
      } else {
        setData(response.json.data)
        setTooFewClients(undefined)
      }
      setLoaded(true);
    }).catch(error => {
      setError('Unknown error (http status ' + error.response.status + ')')
      setLoaded(true)
    })
  }

  const toggleExpanded = (i: number)=> {
    if (expandedFAs.indexOf(i) !== -1) {
      setExpandedFAs(expandedFAs.filter((expanded) => expanded !== i))
    } else {
      setExpandedFAs([...expandedFAs, i])
    }
  }

  const showPerFa = (row: RowInterface, i: number, i2: number) => {
    if (expandedFAs.indexOf(i) > -1) {
      return (
        <div key={"fa_" + i + '_' + i2}>
          <div className="flex justify-between">
            <p className="text-neutral-800">{row.left}:</p>
            <p className="font-medium">{row.right}</p>
          </div>
          <hr className="z-hr my-2"/>
        </div>
      )
    }
    return null
  }

  const renderMain = () => {

    if (!loaded) {
      return <div>Loading data...</div>
    }
    if (error.length > 0) {
      return <div>{error}</div>
    }
    if (tooFewClients !== undefined) {
      return <TooFewClients tooFewClients={tooFewClients}/>
    }

    return (
      <div className="main">
        <div className="mt-4 text-3xl font-medium">Activity data</div>

        <p className="mt-4 text-xl font-medium">AI-Coaching sessions</p>

        <div className="mt-2 z-box">
          {
            data.sessions.map((row, i) => (
              <div key={"sessions_" + i}>
                <div className="flex justify-between">
                  <p className="text-neutral-800">{row.left}:</p>
                  <p className="font-medium">{row.right}</p>
                </div>
                <hr className="z-hr my-2"/>
              </div>
            ))
          }
        </div>
      </div>
    )
  }

  return (
    <div className="main">
      {renderMain()}
    </div>
  );
}